<template>
  <div id="app">
    <Indicator></Indicator>
    <HeaderBar pre-href="../../" pageName="rebuild"></HeaderBar>
    <ScrollCover
      :cover-bg="detectDevice(require('../public/images/cover/rebuild_huang_mob_bg.png'), require('../public/images/cover/rebuild_huang_pad_bg.png') , require('../public/images/cover/rebuild_huang_pc_bg.png'))"
      :cover-video="detectDevice('https://p3.udn.com.tw/921/rebuild/huang/rebuild_huang_vmob.mp4', 'https://p3.udn.com.tw/921/rebuild/huang/rebuild_huang_vpad.mp4' , 'https://p3.udn.com.tw/921/rebuild/huang/rebuild_huang_vpc.mp4')"
      :cover-video-poster="detectDevice('https://p3.udn.com.tw/921/rebuild/huang/rebuild_huang_vmob_bg.jpg', 'https://p3.udn.com.tw/921/rebuild/huang/rebuild_huang_vpad_bg.jpg' , 'https://p3.udn.com.tw/921/rebuild/huang/rebuild_huang_vpc_bg.jpg')"
      cover-title="走過自殺潮<br>百面空手道金牌爭光"
      cover-subtitle="921地震廿年系列 災區重建故事二"
      intro-name="黃泰吉"
      intro-age="年齡：48歲"
      intro-resume="現職：南投旭光高中空手道教練<br>成績單：921地震後，培訓南投災區孩子練空手道，20年來教過約900位高風險家庭孩子，培養百餘名國手，帶領學生勇奪國內外300面金牌。"
    />
    <div id="background-container" class="articleEntry">
      <div  class="container">
        <div class="articleBackgroundParent">
          <div class="articleBackgroundChild"></div>
        </div>
        <div class="articleContent">
          
          <p>2019年大學畢業的高湘琳有著高鼻梁、大眼睛，漂亮秀氣的臉龐絲毫看不出來是空手道選手。20年前，她才三歲，對921大地震的印象早已模糊，只記得跟鄰居的孩子在因為不敢回家而搭建的帳篷中穿梭遊戲，大人對災後重建的愁眉苦臉，孩子們當下是無法理解的。</p>
          
          <p>還有更多無法理解的是，災後幾年內鄰居孩子的媽媽上吊自殺了，同學的爸爸抱著瓦斯桶自殺了，2003年南投縣國姓鄉的自殺率是全國最高。</p>
          
        </div>

        <div class="beggingMercy">

          <p>「災民有人自殺、有人吸毒，有人情緒不穩家暴，孩子怎麼辦？」南投縣草屯鄉旭光高中空手道教練黃泰吉不是921地震災民，卻留在災區20年。他回想當年看到的景象，彷彿昨日歷歷在目，「災後什麼都沒有，只有一個慘字。」</p>

          <p>1999年921大地震，在台中開空手道館的黃泰吉與廖德蘭夫妻，因為聯繫不上住在南投災區的學生，心急地開車奔去，趕到時發現災情慘烈，學生家的房子全倒塌，學生還被壓在瓦礫堆下未被救出，等到救災人員把學生抱出，他們夫妻倆忍不住抱著學生大哭。</p>

          <p>這個學生就是現在國家隊的空手道金牌教練曾麗如，九死一生的她，之後培養出2014年韓國仁川亞運金牌辜翠萍。</p>

          <h3 class="title-margin-top">獻身災區 拯救900個孩子人生</h3>

          <p>看到曾麗如的處境後，黃泰吉心想可以為災區做些什麼時，南投縣國姓國中校長池麗娟請他成立空手道隊，讓心靈痛苦又失去依靠的孩子有個寄託的活動。黃泰吉與廖德蘭一口答應，國姓國中當時也全倒，只剩活動中心，他們找個空地，簡單鋪個軟墊就成立了國姓空手道隊。</p>

          <p>從成立國姓國中空手道隊，到今天擔任旭光高中空手道專班教練，他就像聚集了當地弱勢家庭孩子的安全保壘，20年來拉拔了8、900個孩子，夫妻租下五棟透天厝讓孩子住宿，過著規律的生活。不只孩子的食衣住行全包，連家長的健保費、喪葬費，他都付過。</p>
      
        </div>
      </div>

      <div class="containerImage">
        <img class="containerImage_image" :src="srcRWD(require('../public/images/rebuild_huang_mob1.jpg'), require('../public/images/rebuild_huang_pc1.jpg'))" alt="">
        <p class="containerImage_description">黃泰吉、廖德蘭夫婦（前排中）20年來拉拔數百名出身弱勢家庭的青少年，成為空手道好手，也走出生命的新希望。圖／報系資料照</p>
      </div>

      <div class="container">

        <h3>不畏黑道追殺 教出300面金牌</h3>

        <p>印象最深的是遇到黑道討債，一群黑衣人追殺學生家長。黃泰吉難忘10年前那一晚的恐懼，當時他跟學生家長被10幾個拿著開山刀的黑衣人團團包圍，他先用空手道撂倒幾個人後，心裡不停向天吶喊：「我一輩子不菸不酒、不吸毒，怎麼會遇到這種事！」一邊盤算著該怎麼帶著學生家長衝出重圍時，黑道竟然決定先撤退，讓他們躲過一劫。</p>
        
        <p>黃泰吉講起這段可怕過程時，笑容帶著無奈卻也得意，無奈心疼的是孩子的遭遇，得意的是這20年來，這群孩子很爭氣，他們出身背景不好，卻都抬頭挺胸地走向國際，幫台灣拿下超過300面金牌。</p>
        
        <p>黃泰吉第一代弟子辜翠萍、高湘琳、谷筱霜、石政中等，憑藉空手道走出災區，包括亞運、全中運、新加坡、克羅埃西亞等賽事都是常勝軍。而跟著他練空手道的孩子中也有13人獲得總統教育獎。</p>
      
        <h3 class="title-margin-top">花光積蓄苦撐 一條走了20年的路</h3>

        <p>從28歲到48歲，人生最精華的時期，他都投入在這群孩子身上。</p>

        <p>20年不是一條容易的路，莫忘初衷的代價會比想像中大許多。不只一次追問黃泰吉為什麼？災後3年、10年，救災人員走了，媒體鎂光燈也走了，你為何不走？</p>

        <p>「因為我沒看過這麼可憐的人...，」黃泰吉坦言，自小家境優渥的他，很難想像有人過得如此辛苦，他20來歲，年紀輕輕就創業開道館，原本在冷氣房教空手道賺錢，想也沒想過投入一場非親非故的火線救援，「空手道隊讓孩子住校，有吃有住，白天的體能鍛鍊也能讓孩子忘掉家庭的不愉快。」</p>

      </div>

      <div class="containerImage">
        <img class="containerImage_image" :src="srcRWD(require('../public/images/rebuild_huang_mob2.jpg'), require('../public/images/rebuild_huang_pc2.jpg'))" alt="">
        <p class="containerImage_description">黃泰吉用「空手道救孩子」，除教練角色外，更多時間還扮演家長，給予學生鼓勵和支持。圖／黃仲裕攝影</p>
      </div>

      <div class="container">

        <p>儘管黃泰吉打造了超過300面金牌，但黃泰吉與廖德蘭也有撐不下去的時候，把房子拿去抵押貸款兩次，</p>

        <div class="container_quote">
            <p class="container_quote_words">過去沒錢我都幫了，現在一直有人伸出援手，給予資源，怎麼可能停止？能救一個算一個吧。</p>
        </div>

        <p>921大地震讓國姓鄉112人死亡，超過3000戶的房屋半倒或全倒，孩子們無家可歸，20年前他收容的是災區孩子，卻也沒想到20年後，仍有許多孩子三餐無法正常吃飽。現在租來的五棟透天厝，住滿了這類的孩子，黃泰吉的夢想是蓋一棟空手道宿舍，讓全部的孩子集中住在一起，不再分散各處。</p>

        <h3 class="title-margin-top">帶孩子走出災區 站上國際舞台</h3>

        <p>為什麼想練空手道，每天多達三、五小時的練習，這群孩子難道不想偷懶落跑嗎？曾在國際賽中取得金牌的高湘琳說，確實曾因為想家落跑過，黃泰吉也很阿莎力答應讓不想練的孩子返回山上部落。但是沒三天，高湘琳又下山練空手道了。</p>

        <p>「雖然很累，很辛苦，但生活規律，三餐可以正常吃，」高湘琳說，在山上除了學校營養午餐之外，其餘兩餐不是沒吃，就是只能去同學家搭伙吃。很多同齡的朋友都是這樣長大的，爸媽外出打零工不在家，或是隔代教養，阿公阿嬤忙著務農，下了課孩子沒事做，便群聚抽菸、喝酒，唱卡拉OK。</p>

        <p>黃泰吉的初代弟子鄧世瑀，921地震那天才小學六年級，住在國姓鄉的他親眼看到自己的故鄉毀於一夕，更經歷了鄉裡大人們的自殺潮。空手道讓他轉移對災難的注意力，生活變得有方向感，「當人專注往前看時，時間都過得很快。」</p>

      </div>
      <div class="title-margin-top">
        <three-iamges-box
          :is-not-two-only="false"
          :image-two-src="srcRWD(require('../public/images/rebuild_huang_mob3.jpg'), require('../public/images/rebuild_huang_pc3.jpg'))"
          :image-three-src="srcRWD(require('../public/images/rebuild_huang_mob4.jpg'), require('../public/images/rebuild_huang_pc4.jpg'))"
          image-one-des=""
          :image-two-des="srcRWD('高湘琳（上）從小學六年級就跟著黃泰吉學習空手道，曾在國際賽中摘金。鄧世瑀（下）是黃泰吉的初代弟子，現在從選手轉為教練，他說，空手道讓他找到人生方向。圖／黃仲裕攝影', '高湘琳（左）從小學六年級就跟著黃泰吉學習空手道，曾在國際賽中摘金。鄧世瑀（右）是黃泰吉的初代弟子，現在從選手轉為教練，他說，空手道讓他找到人生方向。圖／黃仲裕攝影')"
        ></three-iamges-box>
      </div>
      <div class="container">
        <p>不僅在國際賽中拿牌，也拿過總統教育獎，如今鄧世瑀從選手轉為教練，「當了教練才了解黃教練的辛苦，為學生張羅吃飯、練習，出國比賽還要募款。部落許多孩子都是有一餐沒一餐，跟隨黃教練的孩子多是高風險家庭，需要全方位照顧，但他們很單純、很乖，能夠專注練習。」</p>

        <p>旭光高中活動中心的地下一樓，是空手道隊的練習場，地板傳來陣陣因為身軀摔倒的聲響。20年前大地震時，旭光高中所有建築都倒塌了，只剩活動中心沒倒塌。天亮之後，災區的孩子們，從山上四面八方來了，在這裡長大茁壯，然後走出災區，站上國際舞台。</p>
      </div>
      <EndOfNavBar
        last-url="../liao/"
        last-name="上一篇"
        next-url="../tzu/"
        next-name="獨老者桃花源"
        page-number="2/6"
        :is-start="false"
        :is-end="false"
      ></EndOfNavBar>
      <GeneralWidget :useMemory="true"/>
    </div>
  </div>
</template>

<script>
import srcRWD from './mixin/srcRWD.js'
import detectDevice from './mixin/detectDevice.js'
import ScrollCover from '../../share_components/ScrollCover.vue'
import ThreeIamgesBox from '../../share_components/ThreeIamgesBox.vue'
import EndOfNavBar from '../../share_components/EndOfNavBar.vue'
import Indicator from '../../../general_components/Indicator.vue'
import HeaderBar from '../../../general_components/HeaderBar.vue'
import GeneralWidget from '../../../general_components/GeneralWidget.vue'
import Relate from '../../../general_components/Relate.vue'
import Comment from '../../../general_components/Comment.vue'
import Logo from '../../../general_components/Logo.vue'
import Author from '../../../general_components/Author.vue'
import Footer from '../../../general_components/Footer.vue'

export default {
  name: 'app',
  data () {
    return {
      isOverNav: false,
      pinArticleBackground: null
    }
  },
  mixins: [srcRWD, detectDevice],
  components: {
    ScrollCover,
    ThreeIamgesBox,
    EndOfNavBar,
    Indicator,
    HeaderBar,
    GeneralWidget,
    Relate,
    Comment,
    Logo,
    Author,
    Footer
  },
  mounted () {
    let controller = new this.$sm.Controller();
    this.pinArticleBackground = new this.$sm.Scene({triggerElement: ".articleBackgroundParent", duration: '1100%', triggerHook: 'onLeave'})
								.setPin(".articleBackgroundParent", {pushFollowers: false})
                .addTo(controller);
  },
  methods: {

  },
  destroyed () {
    this.pinArticleBackground.remove();
  }
}
</script>

<style lang="scss">

@import "../../../sass/main.scss";
@import "../../share_scss/custom.scss";

#app {
  .articleEntry {
    position: relative;
    width: 100%;
    z-index: 1;
    padding-top: 60px;
    background-color: #fff;
    .articleBackgroundParent {
      position: absolute;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      z-index: -1;
      .articleBackgroundChild {
        width: 100%;
        height: 100%;
        background-image: url("../../share_source/background_mob.jpg");
        background-position: center;
        background-size: cover;
        @media (min-width: 768px) and (max-width: 1279.98px) {
          background-image: url("../../share_source/background_pad.jpg");
        }
        @media (min-width: 1280px) {
          background-image: url("../../share_source/background_pc.jpg");
        }
      }
      .fixedUp {
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        z-index: 99999;
      }
    }
    .articleContent {
      position: relative;
      z-index: 10;
      color: $gray;
    }
    .rebuild-img {
      width: 100%;
    }
    .rebuild-img-description {
      color: #7b7a7a;
    }
    .socialBelief {

    }
    .rebuildGeneration {
      margin-top: 60px;
    }
  }
}
</style>
